module.exports = {
  serverHostUrl: 'https://server.krispsystems.net',
  accessToken: ''
}
